// extracted by mini-css-extract-plugin
module.exports = {"Question":"Question_Question__19wKC","QuestionMark":"Question_QuestionMark__kETNT","AnswerList":"Question_AnswerList__3Gpgw","ListItem":"Question_ListItem__3wF4K"};